<template>
  <v-btn
    :height="height"
    depressed
    :rounded="rounded"
    :color="color"
    :large="large"
    :outlined="outlined"
    :loading="loading"
    @click="$emit('handleClick')"
    :class="
      `common-button font-weight-regular ${
        customClassName ? customClassName : ''
      } ${color === 'secondary' ? 'common-button--secondary' : ''} ${
        notCapitalize ? 'common-button--not-capitalize' : ''
      }`
    "
    :min-width="width"
    :disabled="disabled"
  >
    <v-icon v-if="icon" class="mr-2" size="20">{{ icon }}</v-icon>
    {{ label }}
  </v-btn>
</template>

<script>
export default {
  name: "CommonButton",
  props: {
    color: {
      type: String,
      default: "primary"
    },
    label: {
      type: String,
      required: true
    },
    outlined: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    customClassName: {
      type: String,
      default: ""
    },
    width: {
      type: String,
      default: ""
    },
    height: {
      type: String,
      default: ""
    },
    notCapitalize: {
      type: Boolean,
      default: false
    },
    rounded: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.common-button {
  font-size: 0.8rem;
  text-transform: capitalize;
}

.common-button--secondary {
  border: 1px solid var(--grey-color);
}

.common-button--not-capitalize {
  text-transform: none !important;
}
</style>
